import { NgModule } from '@angular/core';
import {
    Routes,
    RouterModule
} from '@angular/router';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { ClientesLayoutComponent } from './layouts/clientes-layout.component';

import { LoginComponent } from './login/login.component';

//Clientes
import { ClientesComponent } from './clientes/clientes.component';
import { ImportarArchivosComponent } from './clientes/importar-archivos/importar-archivos.component';
import { HistoricaComponent } from './clientes/historica/historica.component';
import { AplicadaComponent } from './clientes/aplicada/aplicada.component';
import { EditarClienteComponent } from './clientes/editar/editar-cliente.component';

import { UsuariosComponent } from './usuarios/usuarios.component';
import { NuevoUsuarioComponent } from './usuarios/nuevo-usuario/nuevo-usuario.component';
import { EditarUsuarioComponent } from './usuarios/editar-usuario/editar-usuario.component';
import { RegistroUsuarioComponent } from './usuarios/registro-usuario/registro-usuario.component';
import { OlvidePasswordComponent } from './usuarios/olvide-password/olvide-password.component';
import { NuevoPasswordComponent } from './usuarios/nuevo-password/nuevo-password.component';

import { ParametrosComponent } from './parametros/parametros.component';

import { EnviosComponent } from './envios/envios.component';

import { AuthGuard } from './services/guards/auth-guard';
import { AuthGuardClientes } from './services/guards/auth-guard.clientes';

import { IsLoggedIn } from './services/guards/is-logged-in';


import { AuthGuardIntranet, AuthGuardIntranetAdmin } from './intranet/services/auth-guard.intranet';
import { KairosComponent } from './intranet/kairos/kairos.component';
import { AltaKairosComponent } from './intranet/kairos/alta-kairos/alta-kairos.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent,
        resolve: [IsLoggedIn]
    },
    {
        path: 'usuarios/password/recuperar',
        component: OlvidePasswordComponent
    },
    {
        path: 'usuarios/:id/password/nuevo',
        component: NuevoPasswordComponent
    },
    {
        path: 'clientes/:id/registro',
        pathMatch: 'full',
        component: RegistroUsuarioComponent,
    },
    {
        path: 'dashboard',
        component: FullLayoutComponent,
        data: {
            title: 'Inicio'
        },
        canActivate: [AuthGuard],
        children: [
            {
                path: 'clientes',
                data: {
                    title: 'Clientes'
                },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        component: ClientesComponent,
                        data: {
                            title: 'Listado'
                        }
                    },
                    {
                        path: 'importar',
                        pathMatch: 'full',
                        component: ImportarArchivosComponent,
                        data: {
                            title: 'Importacion Cuenta Corriente'
                        }
                    },
                    {

                        path: 'ctacte/historica',
                        pathMatch: 'full',
                        component: HistoricaComponent,
                        data: {
                            title: 'Cuenta Corriente Historica'
                        }

                    },
                    {

                        path: 'ctacte/aplicada',
                        pathMatch: 'full',
                        component: AplicadaComponent,
                        data: {
                            title: 'Cuenta Corriente Aplicada'
                        }

                    },
                    {
                        path: 'editar',
                        pathMatch: 'full',
                        component: EditarClienteComponent,
                        data: {
                            title: 'Editar'
                        }
                    },
                ]
            },
            {
                path: 'usuarios',
                data: {
                    title: 'Usuarios'
                },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        component: UsuariosComponent,
                        data: {
                            title: 'Listado'
                        }
                    },
                    {
                        path: 'nuevo',
                        pathMatch: 'full',
                        component: NuevoUsuarioComponent,
                        data: {
                            title: 'Nuevo'
                        }
                    },
                    {
                        path: 'editar',
                        pathMatch: 'full',
                        component: EditarUsuarioComponent,
                        data: {
                            title: 'Editar'
                        }
                    },
                ]
            },
            {
                path: 'parametros',
                data: {
                    title: 'Parametros'
                },
                component: ParametrosComponent
            },
            {
                path: 'envios',
                data: {
                    title: 'Envios'
                },
                component: EnviosComponent
            },
            /*Algoritmo*/
        {
            path: 'intranet',
            data: {
                title: 'Intranet'
            },               
            children: [
            {
                path: 'kairos',
                data: {
                    title: 'Kairos'
                },                
                children: 
                [
                    {
                        path: '',
                        pathMatch: 'full',
                        component: KairosComponent,
                        data: {
                            title: 'Listado de Actualizaciones'
                        }
                    },
                    {
                        path: 'alta',
                        pathMatch: 'full',
                        component: AltaKairosComponent, 
                        data: {
                            title: 'Alta'
                        }
                    },
                ]                            
            }
            ]
        },
        /*Fin Algoritmo*/  
        ]
    }, 
    /*Algoritmo*/
    {
        path: 'intranet',
        data: {
            title: 'Intranet'
        },
        component: ClientesLayoutComponent,
        canActivate: [AuthGuardIntranetAdmin],
        children: [
        {
            path: 'kairos',
            data: {
                title: 'Kairos'
            },                
            children: 
            [
                {
                    path: '',
                    pathMatch: 'full',
                    component: KairosComponent,
                    data: {
                        title: 'Listado de Actualizaciones'
                    }
                }
            ]                            
        }
        ]
    },
        /*Fin Algoritmo*/   
    {
        path: 'clientes',
        component: ClientesLayoutComponent,
        data: {
            title: 'Clientes'
        },
        canActivate: [AuthGuardClientes],
        children: [            
            {
                path: 'ctacte/historica',
                pathMatch: 'full',
                component: HistoricaComponent,
                data: {
                    title: 'Cuenta Corriente Historica'
                }
            },
            {
                path: 'ctacte/aplicada',
                pathMatch: 'full',
                component: AplicadaComponent,
                data: {
                    title: 'Cuenta Corriente Aplicada'
                }

            }            
        ]
    },
    
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/app.routing.ts